// Popup "Nâng cấp" dùng chung: gọi showUpgradePopup(...) ở bất kỳ đâu,
// <UpgradePopupHost /> (đặt trong Router ở App.js) sẽ hiển thị.
import { cheapestPlan, formatVnd } from '../config/plans';

export const UPGRADE_POPUP_EVENT = 'aidicho:upgrade-popup';

export const showUpgradePopup = ({ title, message }) => {
  window.dispatchEvent(new CustomEvent(UPGRADE_POPUP_EVENT, { detail: { title, message } }));
};

const PLAN_LABELS = {
  FREE: 'Miễn phí',
  '1MONTH': '1 tháng',
  '3MONTH': '3 tháng',
  '12MONTH': '12 tháng',
  LIFETIME: 'Trọn đời'
};

export const planLabel = (plan) => PLAN_LABELS[plan] || PLAN_LABELS.FREE;

// `me` = userPermissions trong AuthContext (dữ liệu của /api/user/me):
// { plan_type, is_expired, days_remaining, permissions: {...} }
export const expiredPopup = (me) => {
  const plan = me?.plan_type;
  if (!plan || plan === 'FREE') {
    return {
      title: 'Hết thời gian dùng thử',
      message: `Gói miễn phí (dùng thử 14 ngày) của bạn đã hết hạn nên Thực đơn, Thực đơn đã lưu và Món của tôi tạm khóa. Nâng cấp để dùng tiếp (gói ${cheapestPlan().name.toLowerCase()} chỉ ${formatVnd(cheapestPlan().price)}).`
    };
  }
  return {
    title: 'Gói đã hết hạn',
    message: `Gói ${planLabel(plan)} của bạn đã hết hạn nên Thực đơn, Thực đơn đã lưu và Món của tôi tạm khóa. Gia hạn để tiếp tục sử dụng.`
  };
};

export const menuDaysPopup = (me, days) => {
  if (me?.is_expired) return expiredPopup(me);
  const plan = me?.plan_type || 'FREE';

  if (days === 14) {
    return {
      title: 'Thực đơn 14 ngày',
      message: plan === 'FREE'
        ? 'Bạn đang dùng gói miễn phí. Thực đơn 14 ngày chỉ có ở gói 3 tháng trở lên.'
        : `Gói ${planLabel(plan)} chưa có thực đơn 14 ngày. Nâng cấp lên gói 3 tháng hoặc 12 tháng để dùng.`
    };
  }
  if (plan === 'FREE' && (days === 3 || days === 7)) {
    return {
      title: `Hết lượt thực đơn ${days} ngày`,
      message: `Bạn đang dùng gói miễn phí: mỗi loại thực đơn 3 ngày và 7 ngày chỉ được tạo 1 lần, và bạn đã dùng lượt ${days} ngày. Nâng cấp để tạo không giới hạn.`
    };
  }
  return {
    title: 'Cần nâng cấp gói',
    message: 'Gói hiện tại của bạn chưa hỗ trợ lựa chọn này. Nâng cấp để dùng đầy đủ tính năng.'
  };
};

// Dựng popup từ thông báo lỗi 403 của server khi tạo thực đơn (chuỗi `detail`)
export const popupFromServerDetail = (detail, me, days) => {
  const text = String(detail || '');
  if (/hết hạn/i.test(text)) return expiredPopup({ ...me, is_expired: true });
  if (/14 ngày|3 ngày|7 ngày|lượt/i.test(text)) return menuDaysPopup({ ...me, is_expired: false }, days);
  return { title: 'Cần nâng cấp gói', message: text || 'Gói hiện tại của bạn chưa hỗ trợ tính năng này.' };
};
